/// <reference path="../_references.js" />
function nullFormatter(aValue) {
    "use strict";
    var lResult = '';

    //single equal on purpose
    if (!isNullOrUndefined(aValue) && aValue != -1) {
        lResult = aValue;
    }

    return lResult;
}

function blankFormatter(aValue) {
    "use strict";
    return '';
}

function frpFormatter(aLastName, aFirstName, aEmail) {
    "use strict";
    var lPrefix = ['('],
        lPostfix = [],
        lResult

    if (!isNullOrUndefined(aLastName) && aLastName != "") {
        lPrefix.push(aLastName);
    }

    if (!isNullOrUndefined(aFirstName) && aFirstName != "") {
        if (!isNullOrUndefined(aLastName) && aLastName != "") {
            lPrefix.push("," + aFirstName);
        } else {
            lPrefix.push(aFirstName);
        }

    }

    if (lPrefix.length == 1) {
        lPrefix = [];
    } else {
        lPrefix.push(')');
    }

    if (!isNullOrUndefined(aEmail) && aEmail != "") {
        lPostfix.push(" " + aEmail);
    }

    lResult = lPrefix.join('') + lPostfix.join('');
    return lResult;

}

function vehicleColorFormatter(aValue) {
    "use strict";

    if (aValue < 0 || aValue === "Unknown") {
        return '';
    }

    return localizeDataItem('VehicleColor', aValue);
}

function vehicleMakeFormatter(aValue) {
    "use strict";
    if (aValue < 0) {
        return '';
    }

    return localizeDataItem('VehicleMake', capitalize(aValue));
}

function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
//function dataItemFormatter(aCacheName, aPropertyName, aDefaultValue, aId) {
//    "use strict";
//    var lReturn = aDefaultValue,
//        lItem = getDataItem(aId, aCacheName);

//    if (!isNullOrUndefined(lItem)) {
//        lReturn = lItem[aPropertyName];
//    }

//    return lReturn;
//}
function dataItemFormatter(aCacheName, aPropertyName, aDefaultValue, aId, aTableName, aLocalized) {
    "use strict";
    var lReturn = aDefaultValue,
        lLocalized = true,
        lTableName = aTableName,
        lItem = getDataItem(aId, aCacheName);

    if (!isNullOrUndefined(lItem)) {
        lReturn = lItem[aPropertyName];
    }
    if (!isNullOrUndefined(aLocalized)) {
        lLocalized = aLocalized;
    }

    if (lLocalized) {
        if (!lTableName) {
            lTableName = aCacheName;
        }
        lReturn = localizeDataItem(lTableName, lReturn);
    }

    return lReturn;
}

function DisplayLongDateTime(aJsonDate) {
    "use strict";
    //    var lDate = aJsonDate;
    //    if (typeof aJsonDate === 'string') {
    //        lDate = aJsonDate.WcfToDate();
    //    }
    return $.format.date(aJsonDate, "ddd, MMM dd, yyyy hh:mm:ss a");
}

function DisplayShortDateTime(aDate) {
    "use strict";
    //    var lDate = aJsonDate;
    //    if (typeof aJsonDate === 'string') {
    //        lDate = aJsonDate.WcfToDate();
    //    }
    return $.format.date(aDate, "MM/dd/yyyy hh:mm:ss a");
}

function DisplaySuperShortDate(aDate) {
    return $.format.date(aDate, "MM/dd/yyyy");
}

function DisplaySuperShortMomentDate(aMoment, aFormat) {
    var lFormat = "MM/DD/YYYY";

    if (aFormat)
        lFormat = aFormat;
    return aMoment.format(lFormat);
}

function DisplayMomentTime(aMoment) {
    return aMoment.format("MM/DD/YYYY");
}

function DisplayShortMomentTime(aMoment) {
    return aMoment.format("hh:mm a");
}

function displayNumericData(aNumber) {
    "use strict";
    var lNumber = aNumber;
    if (aNumber === 0) {
        lNumber = '';
    }
    return lNumber;
}

/* ENROLLEES FORMATTERS */
function EnrolleeNameFormatter(aEnrolleeId) {
    "use strict";
    return dataItemFormatter('Enrollees', 'FullName', 'UNKNOWN', aEnrolleeId, 'Enrollee', false);
}

function EnrolleePrimaryIdFormatter(aEnrolleeId) {
    "use strict";
    return dataItemFormatter('Enrollees', 'PrimaryId', 'UNKNOWN', aEnrolleeId, 'Enrollee', false);
}

function EnrolleeRiskLevelFormatter(aId) {
    "use strict";
    var lResult = localizeWrapper('cUnknown'),
        lBuilder = new SumoPredicateBuilder(),
        lQuery,
        lKey,
        lItem;
    lBuilder.AddNewExpressionConditional('Id', aId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
   // lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lQuery = query(RiskLevelFormatter(), lBuilder.RootExpression);
    if (!isNullOrUndefined(lQuery)) {
        for (lKey in lQuery) {
            if (lQuery.hasOwnProperty(lKey)) {
                lItem = lQuery[lKey];
                lResult = lItem.Name;
                break;
            }

        }

    }
    return lResult;
}
function VictimRiskLevelFormatter(aId) {
    "use strict";
    var lResult = localizeWrapper('cUnknown');
    var aRiskLevel = getDataItem(aId,'VictimRiskLevels');
    if(aRiskLevel){
        lResult = aRiskLevel.VictimRiskLevelName;
    }
    return lResult;
}

function EnrolleeArchiveFlagFormatter(aFlag) {
    "use strict";
    var lResult = localizeText('cNo');

    if (aFlag == 'Y')
        lResult = localizeText('cYes');

    return lResult;
}

function EnrolleeAlcoholFlagFormatter(aFlag) {
    "use strict";
    var lResults = localizeText('cNo');

    if (aFlag == 1) {
        lResults = localizeText('cYes');
    }

    return lResults;
}

function OffenderPayFlagFormatter(aId) {
    "use strict";
    var lResult = localizeText('cEnrolleeNotEnrolled');

    if (aId != 0 && aId != null && aId != -1) {
        lResult = aId;
    }
    return lResult;
}
//EMA
function CellPhoneNumberFormatter(aCellPhoneNumber) {
    "use strict";
    var lResult = '';

    if (aCellPhoneNumber !== '') {
        lResult = aCellPhoneNumber;
    }
    return lResult;
}
//EMA
function HasEnrolleeMobileAppFormatter(aHasEnrolleeMobileApp) {
    "use strict";
    var txt = localizeWrapper(!!aHasEnrolleeMobileApp?"cYes":"cNo");
    return txt;
}
function FullNameSpecialCharsFormatter(fullName)
{
    var txt = fullName;
    var txt = veritracks.system.decodeHtml(txt);
    txt = veritracks.system.encodeHtml(txt);
    return txt;
}
function ProximityZoneFormatter(a){
    var txt = (a === "-1"||a == -1) ?"-":a.toString()+ 'ft';
    return txt;
}
function OffenderIdFormatter(aOffenderId){
    var lOffender = getDataItem(aOffenderId, 'Enrollees');
    var text = !isNullOrUndefined(lOffender)?lOffender.FullName + ' (' + lOffender.PrimaryId + ')':'';
    return (aOffenderId === "-1"||aOffenderId == -1) ?" ":text;
}
function EnrolleeNameLinkFormatter(aOffenderId){
    var lOffender = getDataItem(aOffenderId, 'Enrollees');
    var text = !isNullOrUndefined(lOffender)?lOffender.FullName:'';
    text = (aOffenderId === "-1"||aOffenderId == -1) ?" ":text;
    var onclick = 'Enrollees.Offenders.Profile.Events.' + aOffenderId.toString();
    var html ='<a class="LinkableItem" href="#'+onclick+'">'+text+'</a>';
    return (aOffenderId === "-1"||aOffenderId == -1)?" ":html;
}
function VictimIdLinkFormatter(aVictimId){
    if(aVictimId){
        var onclick = 'Enrollees.Victims.Profile.Events.' + aVictimId.toString();
        var html ='<a class="LinkableItem" href="#'+onclick+'">'+OffenderIdFormatter(aVictimId)+'</a>';
        return (aVictimId === "-1"||aVictimId == -1)?" ":html;
    }
}
function EnrolleeIdLinkFormatter(aVictimId){
    var onclick = 'Enrollees.Offenders.Profile.Events.' + aVictimId.toString();
    var html ='<a class="LinkableItem" href="#'+onclick+'">'+OffenderIdFormatter(aVictimId)+'</a>';
    return (aVictimId === "-1"||aVictimId == -1)?" ":html;
}

function inventoryEnrolleeNameLinkFormatter(aId,aObject){
    var aEnrollee = GetEnrollee(aId);
    return aEnrollee.EnrolleeType == 1 ?EnrolleeNameLinkFormatter(aId):VictimIdLinkFormatter(aId);
}

function RiskLevelFormatter(aRiskLevels) {
    "use strict";
    var lRiskLevels,
        lBuilder = new SumoPredicateBuilder(),
        lSort = new SortExpression();

    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    if (!isNullOrUndefined(aRiskLevels)) {
        lRiskLevels = query(aRiskLevels, lBuilder.RootExpression);
    }
    else {
        lRiskLevels = query(getDataItems('RiskLevels'), lBuilder.RootExpression);
    }

    lSort.addAscendingColumn("SortOrder");
    lRiskLevels = lSort.sort(lRiskLevels);
    return lRiskLevels;
}

function EventConfirmedFormatter(aIsConfirmed) {
    "use strict";
    var lReturn = localizeWrapper('cNo');

    if (aIsConfirmed) {
        lReturn = localizeWrapper('cYes');
    }

    return lReturn;
}

function EventMostRecentNoteFormatter(aId) {
    "use strict";
    var lReturn = localizeWrapper('cEventNoteText');

    // PROCESSING GOES HERE

    return lReturn;
}

function EventNoteCountFormatter(aId) {
    "use strict";
    var lReturn = 0;

    // PROCESSING GOES HERE

    return lReturn;
}

function AssignmentEndDateFormatter(aJsonDate) {
    "use strict";
    var lDate = aJsonDate, //.WcfToDate(),
        lEpochDate = new Date(0),
        lMaxDate = new Date(),
        lReturn = localizeWrapper('cEnrolleeCurrentlyAssigned');

    if (lDate > lEpochDate && lDate < lMaxDate.addDays(1)) {
        lReturn = DisplayLongDateTime(aJsonDate);
    }

    return lReturn;
}

function AssignmentChargerStatusFormatter(aJsonDate, aStatus) {
    "use strict";
    var lDate = aJsonDate,
        lStatus = aStatus,
        lEpochDate = new Date(0),
        lMaxDate = new Date(),
        lReturn = '';

    if (lDate > lEpochDate && lDate < lMaxDate) {
        if (isNullOrUndefined(aStatus) || aStatus == '') {
            lReturn = localizeText('cMissing');
        } else {
            lReturn = localizeText('c' + aStatus);
        }
    }

    return lReturn;
}

function GMTDateFormatter(aJsonDate) {
    "use strict";
    var lDate = aJsonDate, //.WcfToDate(),
        lEpochDate = new Date(0),
        lMaxDate = new Date(),
        lReturn = localizeWrapper('cEnrolleeCurrentlyAssigned');

    if (lDate > lEpochDate && lDate < lMaxDate) {
        lReturn = DisplayLongDateTime(aJsonDate);
    }

    return lReturn;
}

function dateSelectorFormatter(aDate) {
    "use strict";
    var lDate = new Date(-3000000000000),
        lResult = '';
    if (aDate > lDate) {
        lResult = displayShortDate(aDate);
    }
    return lResult;
}

function timeFormatter(aTime) {
    "use strict";
    var lTime = displayTime(aTime),
        now = displayTime(aTime);
    now.match(/^(0?[1-9]|1[012])(:[0-5]\d) [APap][mM]$/);
    lTime = RegExp.$1;
}

function scheduleZoneTypeFormatter(aId) {
    "use strict";
    var lZoneType = '';
    switch (parseInt(aId)) {
        case 1:
            lZoneType = localizeText('cEnrolleeActive');
            break;
        case 2:
            lZoneType = localizeText('cEnrolleeScheduleSilent');
            break;
        case 3:
            lZoneType = localizeText('cEnrolleeSchedule911');
            break;
    }
    return lZoneType;
}


function genderFormatter(aId) {
    "use strict";
    return dataItemFormatter('Gender', 'Description', 'UNKNOWN', aId);
}

function raceFormatter(aId) {
    "use strict";
    return dataItemFormatter('Race', 'Description', 'UNKNOWN', aId);
}

function colorFormatter(aId) {
    "use strict";
    return dataItemFormatter('Color', 'Description', 'UNKNOWN', aId);
}

function offenseFormatter(aId) {
    "use strict";
    return dataItemFormatter('Offense', 'Description', 'UNKNOWN', aId);
}

function offenderSupervisionTypeFormatter(aId) {
    "use strict";
    return dataItemFormatter('SupervisionType', 'Description', 'UNKNOWN', aId);
}

function offenderLanguageFormatter(aId) {
    "use strict";
    return dataItemFormatter('Languages', 'Description', 'UNKNOWN', aId);
}

function vehicleYearFormatter(aYear) {
    "use strict";
    var lResult = '';
    if (aYear > 0) {
        lResult = aYear;
    }
    return lResult;
}


function EnrolleeUniversalSearchGenerator(aDataItem) {
    "use strict";
    var lSecondaryId = '';
    if (!isNullOrUndefined(aDataItem.SecondaryId)) {
        lSecondaryId = ', ' + aDataItem.SecondaryId;
    }
    return aDataItem.FullName + ' (' + aDataItem.PrimaryId + lSecondaryId + ')';
}

function OffenderTitleCellGenerator(aEnrollee) {
    "use strict";
    var lMasterDiv = $('<div/>', {}).attr('RowId', aEnrollee.Id),
        lNameDiv = $("<div/>", {
            'text': aEnrollee.FullName
        }).attr('RowId', aEnrollee.Id),
        lPrimaryIdDiv = $("<div/>", {
            'text': aEnrollee.PrimaryId
        }).attr('RowId', aEnrollee.Id);

    lNameDiv.appendTo(lMasterDiv);
    lPrimaryIdDiv.appendTo(lMasterDiv);

    return lMasterDiv;
}

function enrolleesScheduleTypeFormatter(aTypeId) {
    "use strict";
    var lResult = '';

    switch (aTypeId) {
        case 1:
            lResult = 'Zone';
            break;
        case 2:
            lResult = 'BLUhome';
            break;
        case 3:
            lResult = 'BLUbox';
            break;
    }

    return lResult;
}
function EnrolleesEventIconColumnFormatter(aEventId) {
    "use strict";
    var lHtml = [];

    lHtml.push('<div title="" class="GridIcon EventIcon16 StopClickBubble');
    lHtml.push('" onclick="enrolleesEventsIcon_OnClick(');
    lHtml.push(aEventId);
    lHtml.push(')"></div>');

    return lHtml.join('');
}
function EnrolleesEMACheckinTime(aEventTime) {
    "use strict";
    var lResult = null,
        lTimeZone = null;

    lTimeZone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId);
    lResult = displayEnrolleeTimeZoneFormatted(aEventTime, lTimeZone);
    return lResult;
}
function EnrolleesEMAEventResultColumnFormatter(aViolationId) {
    "use strict";
    var lHtml = [];

    lHtml.push('<div title="">');
    if (aViolationId === 1) {
        lHtml.push('Passed');
    } else {
        lHtml.push('Failed');
    }

    lHtml.push('</div>');

    return lHtml.join('');
}
function EnrolleesEMAEventIconColumnFormatter(aEMAEventId) {
    "use strict";
    var lHtml = [];

    lHtml.push('<div title="" class="GridIcon EventIcon16 StopClickBubble');
    lHtml.push('" onclick="enrolleesEMAEventsIcon_OnClick(');
    lHtml.push(aEMAEventId);
    lHtml.push(')"></div>');

    return lHtml.join('');
}
function EnrolleesEMAEventImageColumnFormatter(aEMAEventId) {
    "use strict";
    var lHtml = [];

    lHtml.push('<div title="" class="EventListButton');
    lHtml.push('" onclick="enrolleesEMAEventImageIcon_OnClick(');
    lHtml.push(aEMAEventId);
    lHtml.push(')">Image</div>');

    return lHtml.join('');
}
function EnrolleesSoberTrackTestDetailsFormatter(aTestId) {
    var lBuilder = new SumoPredicateBuilder(),
        lMatchingSchedules = [],
        lSelectedSchedule = {},
        lData = mEnrolleesControls.SoberTrackTestsListView.getDataSource();

    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('ScheduleId', aTestId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lMatchingSchedules = query(lData, lBuilder.RootExpression);

    for (var lkey in lMatchingSchedules) {
        if (lMatchingSchedules.hasOwnProperty(lkey)) {
            lSelectedSchedule = lMatchingSchedules[lkey];
            break;
        }
    }

    return [
           '<div title="" class="SoberTrackListButton" ',
           'onclick="enrolleesSoberTrackTestDetailIcon_OnClick(', aTestId, ',', lSelectedSchedule.EnrolleeId, ')" >Details</div>',
        ].join(' ');
}
function EnrolleesSoberTrackTestStatusFormatter(aStatus,aRowData){
    return [
        '<span class=" EnrolleeSoberTrackStatus ','SoberTrack__'+aRowData.StatusId,'SoberTrack__'+aStatus.replace(/\s/g, ''),'">',aStatus,'</span>',
    ].join(' ');
}

function EnrolleesSoberTrackTestIconFormatter(StatusId, aRowData){
    if(aRowData){
        if(aRowData.StatusName.replace(/\s/g, '') === "InProgress"){
            return '  -  ';
        }
    }
    var lMarker ="";
    if(aRowData.IconId !== -1){
        lMarker = veritracks.mapping.iconGenerator.generateMapMarker(mEnrolleesIcon.icons[aRowData.IconId]['IconValue']);
    }
    return [
        '<span class=" EnrolleeSoberTrackIcon" style="background: url(\'',lMarker,'\')" ></span>'
    ].join('');
}
function EnrolleesSoberTrackDateFormatter(aEventTime) {
    "use strict";
    var lResult = null,
        lTimeZone = null;

    lTimeZone = getEnrolleeTimeZone(mEnrolleesControls.CardView.selectedDataItem().Enrollee.Id);
    lResult = displayEnrolleeTimeZoneFormatted(aEventTime, lTimeZone);
    return lResult;
}
function EnrolleesSoberTrackStartDateFormatter(aStartDate,aRowData) {
    "use strict";
    var lResult = null,
        lTimeZone = null;

    lTimeZone = getEnrolleeTimeZone(aRowData.EnrolleeId);
    lResult = displayEnrolleeTimeZoneFormatted(aStartDate, lTimeZone);
    return lResult;
}
function EnrolleesSoberTrackTestResultDateFormatter(aDate,aRowData){
    if(aRowData){
        if(aRowData.StatusName.replace(/\s/g, '') === "InProgress"){
            return '-';
        }
    }
    return EnrolleesSoberTrackDateFormatter(aDate);
}

function EnrolleesEMASelfReportApprovedColumnFormatter(aChangeRequestId) {
    "use strict";
    var lHtml = [];

    lHtml.push('<div title="" id="uEMASelfReportApproveButton' + aChangeRequestId +'" class="EventListButton');
    lHtml.push('" onclick="EMASelfReportWrite_OnClick(');
    lHtml.push(aChangeRequestId);
    lHtml.push(', 3)">Approve</div>');

    return lHtml.join('');
}
function EnrolleesEMALargeSringViewFormatter(aValue,aData) {
    "use strict";
    return  ['<div title="" id="uEMAScrollView" class="EMAListViewOverflow">',
        '<p>',aValue.toString(),'</p>',
        aData.AgentNotes.trim() != "" ?['<p>','<b>\nAgent Reason:\n</b>',aData.AgentNotes.toString(),'</p>'].join(''):'',
        '</div>'
    ].join('');
}

function EnrolleesEMASelfReportDenyColumnFormatter(aChangeRequestId) {
    "use strict";
    var lHtml = [];

    lHtml.push('<div title="" id="uEMASelfReportDenyButton' + aChangeRequestId +'" class="EventListButton');
    lHtml.push('" onclick="EMASelfReportWrite_OnClick(');
    lHtml.push(aChangeRequestId);
    lHtml.push(', 2)">Deny</div>');

    return lHtml.join('');
}
function EnrolleesEMAChangeRequestStatusColumnFormatter(aStatus) {
    "use strict";
    var lHtml = [];

    lHtml.push('<div>');
    if (aStatus === "2") {
        lHtml.push('Denied</div>');
    } else if (aStatus === "3") {
        lHtml.push('Approved</div>');
    }

    return lHtml.join('');
}
function EnrolleesEMASelfReportCategoryColumnFormatter(ChangeRequestTypeId) {
    "use strict";
    var lHtml = [];

    lHtml.push('<div title="">');
    if (ChangeRequestTypeId === "2" ) {
        lHtml.push("Marks & Tattoos");
    } else if (ChangeRequestTypeId === "3") {
        lHtml.push("Weight");
    } else if (ChangeRequestTypeId === "4") {
        lHtml.push("Vehicle Year");
    } else if (ChangeRequestTypeId === "5") {
        lHtml.push("Vehicle Make");
    } else if (ChangeRequestTypeId === "6") {
        lHtml.push("Vehicle Model");
    } else if (ChangeRequestTypeId === "7") {
        lHtml.push("Vehicle Color");
    } else if (ChangeRequestTypeId === "8") {
        lHtml.push("License Plate");
    }
    lHtml.push('</div>');

    return lHtml.join('');
}
function EnrolleesEMATimeoutApprovedColumnFormatter(aEMATimeoutId,aEMAChangeRequest) {
    "use strict";
    var lHtml = [];
    if(aEMAChangeRequest.AgentDecision != '1'){
        return '';
    }
    lHtml.push('<div title="" id="uEMAScheduleRequestApproveButton' + aEMATimeoutId +'" class="EventListButton');
    lHtml.push('" onclick="EMAScheduleWrite_OnClick(');
    lHtml.push(aEMATimeoutId);
    lHtml.push(', 3)">Approve</div>');
    return lHtml.join('');
}
function EnrolleesEMATimeoutDenyColumnFormatter(aEMATimeoutId,aEMAChangeRequest) {
    "use strict";
    var lHtml = [];
    if(aEMAChangeRequest.AgentDecision != '1'){
        return '';
    }
    lHtml.push('<div title="" id="uEMAScheduleRequestDenyButton' + aEMATimeoutId +'" class="EventListButton');
    lHtml.push('" onclick="EMAScheduleWrite_OnClick(');
    lHtml.push(aEMATimeoutId);
    lHtml.push(', 2)">Deny</div>');

    return lHtml.join('');
}
function EnrolleesEMAScheduleTimeColumnFormatter(aTime) {
    "use strict";
    var lHtml = [],
        lDate = new Date(parseInt(aTime.slice(6, 19)));

    lHtml.push('<div class="EventListCenter" title="">');
    lHtml.push(lDate.toDateString() + ' ' + lDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }));
    lHtml.push('</div>');

    return lHtml.join('');
}
function EnrolleesEMAScheduleTypeColumnFormatter(aType) {
    "use strict";
    //TODO: Update this to a hasmap EMAScheduleType
    return ['<div title="">',EMAScheduleType[aType]?EMAScheduleType[aType]:'Timeout','</div>'].join('');
}
function booleanShortFormatter(aValue) {
    "use strict";
    var lResult = '';
    if (aValue) {
        lResult = 'X';
    }
    return lResult;
}

function booleanLongFormatter(aValue) {
    "use strict";
    var lResult = 'false';

    if (aValue) {
        lResult = 'true';
    }

    return lResult;
}

function reservationStatusFormatter(aStatus) {
    "use strict";
    var lStatus;

    switch (aStatus) {
        case 1:
            lStatus = localizeWrapper('cEventOpen');
            break;
        case 2:
            lStatus = localizeWrapper('cEventUsed');
            break;
        case 3:
            lStatus = localizeWrapper('cEventCanceled');
            break;

        case 4:
            lStatus = localizeWrapper('cEventExpired');
            break;
        case 5:
            lStatus = localizeWrapper('cEventClosed');
            break
    }
    return lStatus;
}

function addressTypeFormatter(aType) {
    var lType;
    switch (aType) {
        case 1:
            lType = AddressTypeFormatter('Home');
            break;
        case 2:
            lType = AddressTypeFormatter('Work');
            break;
        case 6:
            lType = AddressTypeFormatter('Transient');
            break;
        default:
            lType = AddressTypeFormatter('Other');
            break;
    }
    return lType;
}

function addressFormatter(aAddress) {
    var lAddress = '';

    if (aAddress) {
        lAddress = aAddress.Street1 + ', ' + aAddress.City + ', ' + aAddress.State;
        if (aAddress.Zip) {
            lAddress += ' ' + aAddress.Zip;
        }
        if (aAddress.ZipCode) {
            lAddress += ' ' + aAddress.ZipCode;
        }
    }

    return lAddress;
}

function scheduleTargetTypeFormatter(aTargetType) {
    var lTargetType;
    if (aTargetType === 'My') {
        lTargetType = '1';
    } else {
        // convert absence to regular
        if (aTargetType === '9')
            return 6
        if (aTargetType === '8')
            return 1
        if (aTargetType === '7')
            return 3
        if (aTargetType === '10')
            return 2

        lTargetType = aTargetType;
    }
    return lTargetType;
}

/*Assignment Formatters */
function AssignmentChangeReasonFormatter(aReason) {
    "use strict";
    var lReason = aReason;

    if (aReason) {
       lReason = localizeDataItem('DeviceChangeReason', aReason);
    }

    return lReason;
}

/* EVENTS FORMATTERS */

function EventOpenFormatter(aIsOpen) {
    "use strict";
    var lReturn = localizeWrapper('cEventClosed');
    if (aIsOpen) {
        lReturn = localizeWrapper('cEventOpen');
    }
    return lReturn;
}

function formatterMetaEvent(aId) {
    "use strict";
    var lResult = '';

    lResult = dataItemFormatter('MetaEvents', 'Description', 'UNKNOWN', aId, 'MetaEvent');

    return lResult;
}

function ReportColumnFormatter(aDescription) {
    "use strict";
    var lResult = '';

    lResult = localizeDataItem('EnrolleeReportColumn', aDescription);

    return lResult;
}
function eventZoneNameFormatter(aZoneId) {
    "use strict";
    var lResult = localizeWrapper('cEventNone');
    if (aZoneId !== -1) {
        lResult = ZoneNameFormatter(aZoneId);
    }
    return lResult;
}

function formatEventConfirmedByUser(aUserId) {
    "use strict";
    var lReturn = localizeWrapper('cEventNotConfirmed');
    if (aUserId > 0) {
        lReturn = UserNameFormatter(aUserId);
    }
    return lReturn;
}

function formatterMinutesandHours(aHours, aMins) {
    "use strict";
    var lReturn,
        lSpace,
        hourWording,
        minWording,
        lHours = aHours,
        lMins = aMins;

    if (lHours == 1) {
        hourWording = lHours + ' ' + localizeWrapper('cTimelineHour');
    }
    else if (lHours > 1) {
        hourWording = lHours + ' ' + localizeWrapper('cTimelineHourPlural');
    }
    else {
        hourWording = '';
    }

    if (lMins == 1) {
        minWording = lMins + ' ' + localizeWrapper('cTimelineMinute');
    }
    else if (lMins > 1) {
        minWording = lMins + ' ' + localizeWrapper('cTimelineMinutePlural');
    }
    else {
        minWording = '';
    }

    if (lHours > 0 && lMins > 0) {
        lSpace = ' ' + localizeWrapper('cAnd') + ' ';
    }
    else if ((lHours > 0 && lMins == 0) || (lHours == 0 && lMins > 0)) {
        lSpace = '';
    }
    else {
        lSpace = '';
    }

    lReturn = hourWording + lSpace +  minWording;

    return lReturn;
}

function formatEventConfirmationDate(aDate) {
    "use strict";
    var lEpochDate = new Date(0),
        lMaxDate = new Date(3000, 1, 1),
        lReturn = localizeWrapper('cEventNotConfirmed');
    if (aDate > lEpochDate && aDate < lMaxDate) {
        lReturn = DisplayShortDateTime(aDate);
    }
    return lReturn;
}

/* ZONES FORMATTERS */

function ZoneNameFormatter(aId) {
    "use strict";
    var lName = localizeText('cUnknown'),
        lObject = GetZone(aId);

    if (lObject !== null) {
        lName = lObject.Name;
    }

    return lName;
}

function BlueBoxZoneFormatter(aId) {
    "use strict";
    var lResult = '',
        lObject = GetZone(aId);

    if (lObject !== null) {
        lResult = "Zone: " + lObject.Name;
    }

    return lResult;
}

function zoneTypeFormatter(aId) {
    "use strict";
    return dataItemFormatter('ZoneType', 'Description', 'UNKNOWN', aId);
}

function zoneScopeFormatter(aId) {
    "use strict";
    return dataItemFormatter('ZoneScope', 'Description', 'UNKNOWN', aId);
}

function zoneShapeFormatter(aId) {
    "use strict";
    return dataItemFormatter('ZoneShape', 'Description', 'UNKNOWN', aId);
}

function zoneIsVisibleFormatter(aId) {
    "use strict";
    if (aId) {
        return dataItemFormatter('IsVisible', 'Description', 'Shown', aId);
    } else {
        return dataItemFormatter('IsVisible', 'Description', 'Hidden', aId);
    }

}

function zoneClassifiedZoneFormatter(aId) {
    "use strict";
    if (aId == -1 || aId == "") {
        return "Unclassified";
    }
    return aId;
}

/* Risk Level FORMATTERS */
function zoneRiskLevelFormatter(aId) {
    "use strict";
    var lName = localizeWrapper('cEnrolleeUnassigned');
    //lObject = GetZone(aid);

    //if (lObject !== null) {
    //    lName = ArrayToStringFormatter(lObject.RiskLevel);
    //}
    if (aId.length !== 0) {
        lName = aId.join(', ');
    }

    return lName;
}

function zoneRadiusFormatter(aId) {
    "use strict";
    var aId2 = sumo.geo.conversion.metersToFeet(aId);
    return Math.round(aId2) * 1.00;
}


/* ANALYSIS FORMATTERS */
function processStatusFormatter(aId) {
    "use strict";
    return dataItemFormatter('ProcessStatus', 'Description', 'UNKNOWN', aId);
}

function dispositionFormatter(aId) {
    "use strict";
    return dataItemFormatter('Disposition', 'Description', 'UNKNOWN', aId);
}

function clearedExceptionFormatter(aId) {
    "use strict";
    return dataItemFormatter('ClearedException', 'Description', '', aId);
}

/* AGENTS FORMATTERS */
function OrganizationNameFormatter(aOrganizationId) {
    "use strict";
    var lName = localizeWrapper('cUnknown'),
        lAgency = getDataItem(aOrganizationId, 'Organizations');

    if (!isNullOrUndefined(lAgency)) {
        lName = lAgency.Name;
    }

    return lName;
}
function OrganizationAddressTitleformatter(aOrganizationAddressId) {
    "use strict";

    var lName = localizeWrapper('cEventNone'),
        lAgencies = getDataItems('OrganizationAddress');

    if (lAgencies == null) {
        return lName;
    }

    for (var key in lAgencies) {
        if (lAgencies.hasOwnProperty(key) && lAgencies[key].Id == aOrganizationAddressId) {
            lName = lAgencies[key].Title;
        }
    }

    return lName;
}

function OrganizationAddressSelectFormatter() {
    "use strict";
    var lHtml = [],
        lAgencyAddress = getDataItems('OrganizationAddress');

    for (var key in lAgencyAddress) {
        if (lAgencyAddress.hasOwnProperty(key)) {
            lHtml.push('<option value="' + lAgencyAddress[key].Id + '">' + lAgencyAddress[key].Title + '</option>');
        }
    }//end of for

    lHtml.push('<option value="0">' + localizeText('cEventNone') + '</option>');

    return lHtml.join('');
}

function EnrolleeAssignedFormatter(aName) {
    "use strict";
    var lName = localizeWrapper('cEnrolleeUnassigned');

    if (!isNullOrUndefined(aName)) {
        if (aName) {
            lName = localizeWrapper('cEnrolleeAssigned');
        }
    }

    return lName;
}

function multiSelectOrganizationNameFormatter(aOrganizationId) {
    "use strict";
    var lName = '[multiple selected]';
    if (aOrganizationId !== -1) {
        lName = OrganizationNameFormatter(aOrganizationId);
    }
    return lName;
}


function AgentNameFormatter(aAgentId) {
    "use strict";
    var lName = localizeWrapper('cUnknown'),
        lAgent = getDataItem(aAgentId, 'Agents');

    if (!isNullOrUndefined(lAgent)) {
        lName = lAgent.FullName;
    }

    return lName;
}

function agentNameFormatterByUserId(aUserId) {
    "use strict";
    var lName = localizeWrapper('cUnknown'),
        lAgent = getDataItem(aUserId, 'Users');

    if (!isNullOrUndefined(lAgent)) {
        lName = lAgent.FullName;
    }
    else {
        lName = '';
    }

    return lName;
}

function agentNotificationScopeFormatter(aId) {
    "use strict";
    var lResult = localizeWrapper('cAgentMyEnrollees');

    if (aId === 2) {
        lResult = localizeWrapper('cAgentAgencysEnrollees');
    }
    return lResult;
}

function agentNotificationTypeFormatter(aId) {
    "use strict";
    return dataItemFormatter('NotificationType', 'Name', 'UNKNOWN', aId);
}

function agentNotificationHitLevelFormatter(aId) {
    "use strict";
    return dataItemFormatter('HitLevel', 'Description', 'UNKNOWN', aId);
}

function agentNotificationRiskLevelFormatter(aId) {
    "use strict";
    var lOrganizationId = $('#uImmediateNotificationOrganizationIdEdit').val(),
        lId = aId;
    if (!isNullOrUndefined(lOrganizationId)) {
        lId = aId + '.' + lOrganizationId + '.';
    }
    return dataItemFormatter('RiskLevels', 'Name', 'UNKNOWN', lId, 'RiskLevel', false);
}

function victimContactTypeFormatter(aId) {
    "use strict";
    var lResult = localizeWrapper('cAgentPrimaryEmail');

    switch (aId) {
        case 2:
            lResult = localizeWrapper('cAgentSecondaryEmail');
            break;
        case 3:
            lResult = localizeWrapper('cAgentEscalationPlan');
            break;
    }
    return lResult;
}
function agentNotificationContactTypeFormatter(aId) {
    "use strict";
    var lResult = localizeWrapper('cAgentPrimaryEmail');
    switch (aId) {
        case 1:
            lResult = localizeWrapper('cAgentPrimaryEmail');
            break;
        case 2:
            lResult = localizeWrapper('cAgentSecondaryEmail');
            break;
        case 3:
            lResult = localizeWrapper('cAgentPrimaryPhone');
            break;
    }
    return lResult;
}

function agentNotificationUserPriorityFormatter(aId) {
    "use strict";
    switch(aId){
      case 1:
        return aId + 'st';
      case 2:
        return aId + 'nd';
      case 3:
        return aId + 'rd';
      default:
        return "Unknown";
    }
}

function agentNotificationContactFormatFormatter(aId){
  'use strict';
  var lFormats = getDataItems('UserContactFormat'),
    lResults = "Unknown";

  for (var key in lFormats){
    if (lFormats.hasOwnProperty(key)){
      if (lFormats[key].Id == aId){
        return lFormats[key].ContactFormatName;
      }
    }
  }//end of for

  return lResults;
}

function agentEscalationPlanContactMethodFormatter(aData) {
    "use strict";
    var lAgent = getDataItem(aData.AgentId, 'Agents');

    var lResult = lAgent.FirstContactName || 'First Contact';

    if (aData.ContactTypeId == 2) {
        lResult = lAgent.SecondContactName || 'Second Contact';
    }

    return lResult;
}

function agentWorkingHoursFormatter(aId) {
    "use strict";
    var lResult = localizeWrapper('cAgentOffHours');

    if (aId == 2) {
        lResult = localizeWrapper('cAgentNormalHours');
    }

    return lResult;
}

function agentWritablePermissionFormatter(aId) {
    "use strict";
    var lResult = localizeText('cAgentUnset');
    switch (aId) {
        case 0:
            lResult = localizeText('cAgentDeny');
            break;
        case 1:
            lResult = localizeText('cAgentRead');
            break;
        case 2:
            lResult = localizeText('cAgentReadWrite');
            break;
    }
    return lResult;
}

function agentReadablePermissionFormatter(aId) {
    "use strict";
    var lResult = localizeText('cAgentUnset');
    switch (aId) {
        case 0:
            lResult = localizeText('cAgentDeny');
            break;
        case 1:
            lResult = localizeText('cAgentGrant');
            break;
    }
    return lResult;
}


function AgentUniversalSearchGenerator(aDataItem) {
    "use strict";
    return aDataItem.FullName + ' (' + aDataItem.UserName + ')';
}

function ZoneUniversalSearchGenerator(aDataItem) {
    "use strict";
    return aDataItem.Name;
}


/*INVENTORY FORMATTERS*/
function selectionColumnFormatter(aValue) {
    "use strict";
    return '<div class="SelectionIcon"></div>';
}

function ProductNameFormatter(aProductId) {
    "use strict";
    var lName = localizeWrapper('cUnknown'),
        lProduct = getDataItem(aProductId, 'Products');

    if (lProduct != null) {
        lName = lProduct.Name;
    }

    return lName;
}

function PhoneNumberFormatter(aPhone) {
    "use strict";
    var lPhone = "";

    if (aPhone)
        lPhone = aPhone.replace(/\D/g, '');

    return aPhone;
}
function bluHomePhoneNumberFormatter(aPhone) {
    "use strict";
    var lReturn = '-No Phone-';
    if (aPhone !== '' && aPhone >= 1000000) {
        lReturn = aPhone.toString();
    }
    return lReturn;
}

function deviceProductNameFormatter(aDeviceId) {
    "use strict";
    var lReturn = localizeWrapper('cUnknown'),
        lDevice = GetDevice(aDeviceId);

    if (lDevice != null) {
        lReturn = ProductNameFormatter(lDevice.ProductId);
    }

    return lReturn;
}

function DeviceSerialNumberFormatter(aDeviceId) {
    "use strict";
    var lReturn = localizeWrapper('cUnknown'),
        lDevice = GetDevice(aDeviceId);

    if (lDevice != null) {
        lReturn = lDevice.SerialNumber;
    }

    return lReturn;
}

function DeviceStatusNameFormatter(aStatusId) {
    "use strict";
    var lName = localizeWrapper('cUnknown'),
        lStatus = getDataItem(aStatusId, 'DeviceStatuses');

    if (lStatus != null) {
        lName = '<span style="white-space:nowrap">' + localizeDataItem('DeviceStatus', lStatus.Name) + '</span>';
    }

    return lName;
}

function multiSelectDeviceStatusNameFormatter(aStatusId) {
    "use strict";
    var lName = '[multiple selected]';
    if (aStatusId !== -1) {
        lName = DeviceStatusNameFormatter(aStatusId);
    }
    return lName;
}
//Continue Here
function DeviceModeNameFormatter(aStatusId) {
    "use strict";
    var lName = localizeWrapper('cUnknown');

    switch (aStatusId) {
        case 1:
        case "1":
            lName = localizeWrapper('cInventoryActive');
            break;
        case 2:
        case "2":
            lName = localizeWrapper('cInventoryPassive');
            break;
        case 3:
        case "3":
            lName = localizeWrapper('cInventoryHybrid');
            break;
    }

    return lName;
}

function multiSelectDeviceModeNameFormatter(aStatusId) {
    "use strict";
    var lName = '[multiple selected]';
    if (aStatusId !== -1) {
        lName = DeviceModeNameFormatter(aStatusId);
    }
    return lName;
}

function deviceBatteryLevelFormatter(aDeviceId) {
    "use strict";
    var lLastContact = getDeviceLastContact(aDeviceId),
        lImage = '';
    if (lLastContact !== null) {
        lImage = inventoryBatteryLevelFormatter(lLastContact.BatteryLevel);
    } else {
        lImage = inventoryBatteryLevelFormatter(0);
    }
    return lImage;
}

function batteryLevelTextFormatter(aBatteryLevel) {
    "use strict";
    var lLevel = '';

    lLevel = localizeDataItem('BatteryLevel', aBatteryLevel.Description);

    return localizeText('cInventoryBatteryLevel') + ' ' + lLevel;
}
function deviceLastContactFormatter(aDeviceId) {
    "use strict";
    var lastContact = getDeviceLastContact(aDeviceId),
        lResult = '';

    if (!isNullOrUndefined(lastContact)) {
        lResult = DisplayShortDateTime(lastContact.ContactDate);
    }

    return lResult;
}

function deviceBatteryPercentageFormatter(aBatteryLevel) {
    if (isNullOrUndefined(aBatteryLevel) || aBatteryLevel === 0) return '';
    return aBatteryLevel + '%';
}
function inventoryBatteryLevelFormatter(aBatteryLevel) {
    "use strict";
    if (aBatteryLevel) {
        var lResult = '<div class="GridIcon"></div>';
        var lBatteryLevel = getBatteryInfo(aBatteryLevel);
        var lTitleBatteryLevel = batteryLevelTextFormatter(lBatteryLevel)
        if (lBatteryLevel) {
            lResult = '<div title="' + lTitleBatteryLevel + '" class="GridIcon InventoryBattery' + lBatteryLevel.IconId + '"></div>';
        }
    }
    return lResult;
}

function getBatteryInfo(aId) {
    "use strict";
    var lBatteryLevel = getDataItem(aId, 'BatteryLevel');

    return lBatteryLevel;
}

function getBatteryIcon(aId) {
    var lIcon = 0,
        lBatteryLevel;

    lBatteryLevel = getDataItem(aId, 'BatteryLevel');
    if (lBatteryLevel) {
        lIcon = lBatteryLevel.IconId;
    }

    return lIcon;
}

function victimLevelFormatter(aEventSummary) {
    "use strict";
    var lResult = '';
    if (aEventSummary) {
        var lVictimLevel = getVictimEventLevelInfo(aEventSummary);
        lResult = lVictimLevel;
    }
    return lResult;
}

function getVictimEventLevelInfo(aEventSummary) {
    "use strict";
    //Check ProximityCaution, ProximityWarning, ProximityDanger values here to set icon. If they are all -1 thenshow no threat icon.
    var result = '';
    if (aEventSummary.ProxiCautionEventIndicator)
        result = 'VictimEventLevelIconProperty0';
    if (aEventSummary.ProxiWaningEventIndicator)
        result = 'VictimEventLevelIconProperty1';
    if (aEventSummary.ProxiDangerEventIndicator)
        result = 'VictimEventLevelIconProperty2';
    if (aEventSummary.ProxiCriticalEventIndicator)
        result = 'VictimEventLevelIconProperty3';
    //if (result.length === 0)
    //    result = 'VictimEventLevelIconProperty0';

    return result;
}

function getVictimLevelDesc(aEventSummary) {
    "use strict";
    //Check ProximityCaution, ProximityWarning, ProximityDanger values here to set icon. If they are all -1 thenshow no threat icon.
    var result = '';
    if(aEventSummary.ProxiCautionEventIndicator)
        result = localizeText('cEnrolleeProxCaution');
    if (aEventSummary.ProxiWaningEventIndicator)
        result = localizeText('cEnrolleeProxWarning');
    if (aEventSummary.ProxiDangerEventIndicator)
        result = localizeText('cEnrolleeProxDanger');
    if (aEventSummary.ProxiCriticalEventIndicator)
        result = localizeText('cEnrolleeProxCritical');
    //if (result.length === 0)
    //    result = 'No proximity alerts';

    return result;
}

function devicecontactStatusImageFormatter(aDeviceId) {
    "use strict";
    var lLastContact = getDeviceLastContact(aDeviceId),
        lImage = '';
    if (lLastContact != null) {
        lImage = contactStatusImageFormatter(lLastContact.Status);
    } else {
        lImage = contactStatusImageFormatter(0);
    }
    return lImage;
}

function contactStatusImageFormatter(aStatus) {
    "use strict";

    var lResult = '<div class="GridIcon"></div>';
    if (aStatus > 0) {
        switch (aStatus) {
            case 1: // device ok
                lResult = '<div title='+ localizeTitleFormatter('device okay') +' class="GridIcon DeviceOk"></div>';
                break;
            case 2: // device warning
                lResult = '<div title=' + localizeTitleFormatter('device warning') + ' class="GridIcon DeviceWarning"></div>';
                break;
            case 3: // device critical
                lResult = '<div title=' + localizeTitleFormatter('device critical') + ' class="GridIcon DeviceCritical"></div>';
                break;
        }
    }
    return lResult;
}

function ContactStatusNameFormatter(aStatus) {
    "use strict";
    var lName = localizeWrapper('cInventoryCritical');

    if (aStatus === 1) {
        lName = localizeWrapper('cOk');
    } else if (aStatus === 2) {
        lName = localizeWrapper('cInventoryWarning');
    }
    return lName;
}

function DeviceAgencyNameFormatter(aDeviceId) {
    "use strict";
    var lDevice = GetDevice(aDeviceId),
        lName = localizeWrapper('cUnknown');

    if (typeof lDevice !== 'undefined' && lDevice !== null) {
        lName = OrganizationNameFormatter(lDevice.OrganizationId);
    }
    return lName;
}

function BatteryStateFormatter(aId) {
    "use strict";
    var lReturn = localizeWrapper('cGood');

    if (aId === 2) {
        lReturn = localizeWrapper('cBad');
    }
    return lReturn;
}

function DeviceClusterNameFormmater(aGroup) {
    "use strict"
    var lResult = '',
        lCluster = getDataItem(aGroup.DeviceClusterId, 'DeviceClusters');

    if (!isNullOrUndefined(lCluster)) {
        lResult = lCluster.Name;
    }

    return lResult;
}

function DeviceDirectionFormatter(aDegree) {
    "use strict";
    var lReturn = 'N';

    if (aDegree >= 12 && aDegree <= 33) {
        lReturn = 'NNE';
    } else if (aDegree >= 34 && aDegree <= 56) {
        lReturn = 'NE';
    } else if (aDegree >= 57 && aDegree <= 78) {
        lReturn = 'ENE';
    } else if (aDegree >= 79 && aDegree <= 101) {
        lReturn = 'E';
    } else if (aDegree >= 102 && aDegree <= 123) {
        lReturn = 'ESE';
    } else if (aDegree >= 124 && aDegree <= 146) {
        lReturn = 'SE';
    } else if (aDegree >= 147 && aDegree <= 168) {
        lReturn = 'SSE';
    } else if (aDegree >= 169 && aDegree <= 191) {
        lReturn = 'S';
    } else if (aDegree >= 192 && aDegree <= 213) {
        lReturn = 'SSW';
    } else if (aDegree >= 214 && aDegree <= 236) {
        lReturn = 'SW';
    } else if (aDegree >= 237 && aDegree <= 258) {
        lReturn = 'WSW';
    } else if (aDegree >= 259 && aDegree <= 281) {
        lReturn = 'W';
    } else if (aDegree >= 282 && aDegree <= 303) {
        lReturn = 'WNW';
    } else if (aDegree >= 304 && aDegree <= 326) {
        lReturn = 'NW';
    } else if (aDegree >= 327 && aDegree <= 348) {
        lReturn = 'NNW';
    }
    lReturn += ' (' + aDegree.toString() + '&deg;)';

    return lReturn;
}

function mapTrackTypeFormatter(aTypeId) {
    "use strict";
    var lResult = localizeWrapper('cEnrolleeTripsVisits');
    if (aTypeId === 2) {
        lResult = localizeWrapper('cEnrolleeTrackpoints');
    }
    return lResult;
}

function DeviceProductSortFormatter(aData) {
    "use strict";
    var lSort = new SortExpression(),
        lProducts;

    if (!isNullOrUndefined(aData)) {
        lProducts = aData
    }
    else {
        lProducts = getDataItems('Products');
    }

    lSort.addAscendingColumn('Name');
    lProducts = lSort.sort(lProducts);

    return lProducts;
}

function DeviceStatusSortFormatter(aData) {
    "use strict";
    var lSort = new SortExpression(),
        lDeviceStatuses;

    if (!isNullOrUndefined(aData)) {
        lDeviceStatuses = aData
    }
    else {
        lDeviceStatuses = getDataItems('DeviceStatuses');
    }

    lSort.addAscendingColumn('Name');
    lDeviceStatuses = lSort.sort(lDeviceStatuses);

    return lDeviceStatuses;
}

function OrganizationSortFormatter(aData) {
    "use strict";
    var lSort = new SortExpression(),
        lSortArray = [],
        lOrganizations;

    if (!isNullOrUndefined(aData)) {
        lOrganizations = aData
    }
    else{
        lOrganizations = getDataItems('Organizations');
    }

    for (var key in lOrganizations) {
        if (lOrganizations.hasOwnProperty(key)) {
            lOrganizations[key].Name = lOrganizations[key].Name.trim();
        }
    }

    lSort.addAscendingColumn('Name');
    lOrganizations = lSort.sort(lOrganizations);

    return lOrganizations;
}

function DeviceLastContactSortFormatter() {
    "use strict";
    var lLastContacts = [
        { 'Name': localizeText('cOneDay'), 'Id': (3600 * 24 * 1000) },
        { 'Name': localizeText('cOneWeek'), 'Id': (3600 * 168 * 1000) },
        { 'Name': localizeText('cOneMonth'), 'Id': (3600 * 672 * 1000) },
        { 'Name': localizeText('cOlder'), 'Id': (3600 * 673 * 1000) }];
    return lLastContacts;
}

function RoleSortFormatter(aData) {
    "use strict";
    var lSort = new SortExpression(),
        lRoles;

    if (!isNullOrUndefined(aData)) {
        lRoles = aData
    }
    else {
        lRoles = getDataItems('UserRoleValueTypes');
    }

    lSort.addAscendingColumn('Id');
    lRoles = lSort.sort(lRoles);

    return lRoles;
}

function EnrolleeSortFormatter(aData) {
    "use strict";
    var lSort = new SortExpression(),
    lEnrollees;
    if (!isNullOrUndefined(aData)) {
        lEnrollees = aData;
    }
    else {
     lEnrollees = getDataItems('Enrollees');
    }
    lSort.addAscendingColumn('LastName');
    lEnrollees = lSort.sort(lEnrollees);

    return lEnrollees;
}

function VehicleColorSortFormatter(aData) {
    "use strict";
    var lSort = new SortExpression();
    var lColors = [];
    lSort.addAscendingColumn("Description");
    if (aData) {
        lColors = lSort.sort(aData);

    } else {
        lColors = lSort.sort(getDataItems('VehicleColor'));
    }

    return lColors;
}

function VehicleMakeSortFormatter(aData) {
    "use strict";
    var lSort = new SortExpression();
    var lVehicleMakes = [];
    lSort.addAscendingColumn("Description");
    if (aData) {
        lVehicleMakes = lSort.sort(aData);

    } else {
        lVehicleMakes = lSort.sort(getDataItems('VehicleMake'));
    }

    return lVehicleMakes;
}
function AnalysisIncidentFormatter(aData) {
    "use strict";
    var lSort = new SortExpression(),
        lAnalysis = aData;

    lSort.addDescendingColumn('StartDate');
    lAnalysis = lSort.sort(lAnalysis);

    return lAnalysis;
}

function ZonesSortFormatter(aData) {
    "use strict";
    var lSort = new SortExpression(),
        lZones;
    if (!isNullOrUndefined(aData)) {
        lZones = aData;
    }
    else {
        lZones = getDataItems('Zones');
    }
    lSort.addAscendingColumn('Name');
    lZones = lSort.sort(lZones);

    return lZones;
}

function AgentsSortFormatter(aData) {
    "use strict";
    var lSort = new SortExpression(),
        lBuilder = new SumoPredicateBuilder(),
    lAgents;

    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    if(!isNullOrUndefined(aData)){
        lAgents = query(aData, lBuilder.RootExpression);
    }
    else {
        // add isactive flag here
     lAgents = query(getDataItems('Agents'), lBuilder.RootExpression);
    }

    lSort.addAscendingColumn('FullName');
    lAgents = lSort.sort(lAgents);

    return lAgents;
}

function EventsSortFormatter(aData) {
    "use strict";
    var lSort = new SortExpression(),
        lEvents;

    if (!isNullOrUndefined(aData)) {
        lEvents = aData
    }
    else {
        lEvents = getDataItems('Events');
    }
    lSort.addDescendingColumn('StartDateUTC');
    lEvents = lSort.sort(lEvents);

    return lEvents;
}

function ScheduleSortHourFormatter(aData) {
    "use strict";
    var l,
        t,
        i = 0,
        j = 0,
        swapping;
    // bubble sort by hour and minutes

    for (i = 0; i < ObjectLength(aData) ; i++) {
        for (j = i + 1; j < ObjectLength(aData) ; j++) {
            var h = { 'Hour': aData[i].StartTime.getHours(), 'Minutes': aData[i].StartTime.getMinutes() };
            var g = { 'Hour': aData[j].StartTime.getHours(), 'Minutes': aData[j].StartTime.getMinutes() };
            if (aData[i].StartTime.getHours() > aData[j].StartTime.getHours()) {
                swapping = aData[i];
                aData[i] = aData[j];
                aData[j] = swapping;
            } else if (aData[i].StartTime.getHours() >= aData[j].StartTime.getHours()) {
                if (aData[i].StartTime.getMinutes() >= aData[j].StartTime.getMinutes()) {
                    swapping = aData[i];
                    aData[i] = aData[j];
                    aData[j] = swapping;
                }
            }
        }
    }

    return aData;
}

function ReportScheduleDailySortFormatter() {
    "use strict";
    var lList = getDataItems('ReportScheduleDates');
    var lSort = new SortExpression();

    lSort.addAscendingColumn('TimeSpanSort');

    lList = lSort.sort(lList);

    return lList;
}

function ReportScheduleTimeSortFormatter() {
    "use strict";
    var lList = getDataItems('ReportScheduleTimes');
    var lSort = new SortExpression();

    lSort.addAscendingColumn('Id');

    lList = lSort.sort(lList);
    return lList;
}


function ReportScheduleTimeSpanSortFormatter() {
    "use strict";
    var lList = getDataItems('ReportScheduleTimeSpans');
    var lSort = new SortExpression();

    lSort.addAscendingColumn('TimeSpanSort');

    lList = lSort.sort(lList);
    return lList;
}

function reportScheduleDateFormatter(aId) {
    "use strict";
    var lValue = '',
        lScheduleDate = getDataItem(aId, 'ReportScheduleDates');

    if (lScheduleDate) {
        lValue = localizeDataItem('ReportScheduleDate', lScheduleDate.TimeSpanName);
    }

    return lValue;
}

function reportScheduleTimeFormatter(aId) {
    "use strict";
    var lValue = '',
        lScheduleTimes = getDataItem(aId, 'ReportScheduleTimes');

    if (lScheduleTimes) {
        lValue = lScheduleTimes.Times;
    }

    return lValue;
}

function reportScheduleTimeSpanFormatter(aId) {
    "use strict";
    var lValue = '',
        lScheduleTimeSpan = getDataItem(aId, 'ReportScheduleTimeSpans');

    if (lScheduleTimeSpan) {
        lValue = localizeDataItem('ReportScheduleTimespan', lScheduleTimeSpan.TimeSpanName);
    }

    return lValue;
}

function reportEmailFormatFormatter(aId) {
    "use strict";
    var lValue = '',
        lEmailFormat = getDataItem(aId, 'EmailFormats');

    if (lEmailFormat) {
        lValue = localizeDataItem('EmailFormat', lEmailFormat.EmailFormatText);
    }

    return lValue;
}

function reportNameFormatter(aId) {
    "use strict";
    var lValue = '',
        lReport = getDataItem(aId, 'Reports');

    if (lReport) {
        lValue = localizeDataItem('Report', lReport.Name);
    }

    return lValue;
}

function ReportNameFormatter(aName) {
    return localizeDataItem('Report', aName);
}

function ReportDescriptionFormatter(aDescription) {
    "use strict";
    var lDescription = localizeDataItem('Report', aDescription);

    return lDescription;
}

function enrolleesPotentialTripIconFormatter() {
    "use strict";

    return " <img src='Images/Maps/potentialTrip.png' width='16' height='16' title='" + localizeText('cPotentialTrip') + "'>"
}

function enrolleesCarveOutIconFormatter(aAddressId) {
    "use strict";
    var lAddress = getDataItem(aAddressId, 'AddressType');
    var lDescription = lAddress.Description;
    switch (lDescription) {
        case "HOME":
            return generateAddressIcon("Track10500000IconProperty", lAddress.Id);
        case "WORK":
            return generateAddressIcon("Track10600000IconProperty", lAddress.Id);
        case "TRANSIENT":
            return generateAddressIcon("Track10700000IconProperty", lAddress.Id);
        case "OTHER":
            return generateAddressIcon("Track10700000IconProperty", lAddress.Id);
    }

    function generateAddressIcon(icon, aType) {
        return '<div class="MapLegendIcon ' + icon + '" title="' + addressTypeFormatter(aType)+ '"></div>';
    }

}
function enrolleesEventMapIconFormatter(aEvent, aConfirmed, aAssociationActualIcon) {
    "use strict";
    var lEventHtml = '';
    var lConfirmed = aConfirmed;
    var lAssociationActualIcon = aAssociationActualIcon;
    var lDescription;

    if (!isNullOrUndefined(aConfirmed)) {
        lConfirmed = aConfirmed;
    } else {
        lConfirmed = aEvent.IsConfirmed;
    }

    if (aEvent.MetaEventId != 2001) {
        lDescription = formatterMetaEvent(aEvent.MetaEventId);
        if (lConfirmed) {
            lEventHtml = " <img src='" + mChartingCalendarEventIcons[aEvent.MetaEventId] + 'confirmed' + '.png' + "' width='16' height='16' title='" + lDescription + "'>";
        }
        else {
            lEventHtml = " <img src='" + mChartingCalendarEventIcons[aEvent.MetaEventId] + '.png' + "' width='16' height='16' title='" + lDescription + "'>";
        }

    }
    else {

        if (lAssociationActualIcon == 2002) {
            lAssociationActualIcon = 2002;
        }
        else {
            lAssociationActualIcon = 2001;
        }

        lDescription = localizeTitleFormatter('Association');

        lEventHtml = " <img src='" + mChartingCalendarEventIcons[lAssociationActualIcon] + '.png' + "' width='16' height='16' title='" + lDescription + "'>";
    }

    return lEventHtml;
}

function SMSOptInFormatter(aId) {
    var lValue = '';

    switch (aId) {
        case 1:
            lValue = localizeText('cAgentSMSEnabledOn');
            break;
        default:
            lValue = localizeText('cAgentNotEnabled');
            break;
    }

    return lValue;
}

function PasswordPolicyFormatter(aPasswordPolicy) {
    "use strict";
    var lValue = localizeText('cAgentPasswordPolicyDisabled');

    if (aPasswordPolicy) {
        lValue = localizeText('cAgentPasswordPolicyEnforced');
    }

    return lValue;
}

function FeaturePreviewTextFormatter(aPreference) {
    "use strict";
    var lValue = localizeWrapper('cAgentNotEnabled');

    if (aPreference == 1) {
        lValue = localizeWrapper('cAgentEnabled');
    }

    return lValue;
}

function autoDashboardFormatter(aPreference) {
    "use strict";
    var lValue = localizeWrapper('cManual');

    if (aPreference == 1) {
        lValue = localizeWrapper('cAutomatic');
    }

    return lValue;
}

function AbsentScheduleNameFormatter(aMasterName, aStart, aEnd) {
    "use strict";
    var lName = '';
    var lStart = aStart.format("ddd");
    var lEnd = aEnd.format("ddd");

    if (lStart == lEnd) {
        lName = lStart;
    } else {
        lName = lStart + " " + lEnd;
    }
    return lName + " " + aStart.format("h mm A") + " " + aEnd.format("h mm A");
}


function getObjectProperty(ObjectList, property, val, lookingFor) {
    "use strict";
    var result = '';
    for (var lKey in ObjectList) {
        if (ObjectList.hasOwnProperty(lKey)) {
            if (ObjectList[lKey][property] === val) {
                result = ObjectList[lKey][lookingFor];
                break;
            }
        }
    }

    return result;
}

function convertBoolToInteger(aBool){
  return aBool ? 1:0;
}
function IntegerToBoolFormatter(aInt){
    return aInt ? true:false;
  }

//enrollee pay formatters

function EnrolleePayTransTypeFormatter(aValue) {
    "use strict";
    var lResult = "",
        lTypes = ['CRD','CSR','DBT','FIN','INV','LOX','SYS'],
        lTypesConv = ['Credit Memo', 'Cash Receipts', 'Debit Memo', 'Finance Charge', 'Invoice', 'Lockbox Receipt', 'System Invoice'];

    for (var key in lTypes) {
        if (lTypes.hasOwnProperty(key)) {
            if (lTypes[key] == aValue) {
                lResult = lTypesConv[key];
                break;
            }//end of if
        }//end o fif
    }//end of for

    return lResult;
}

function moneyFormatter(aValue) {
    "use strict";
    var lResult = '';
    if (aValue !== null && aValue !== '') {
        var intValue = parseInt(aValue);
        if (intValue < 0) {
            lResult = '-$' + (aValue * -1);
        } else {
            lResult = '$' + aValue;
        }

    }

    return lResult;
}

function formatRemoveSpan(aString) {
    return aString.replace(/<\/?span[^>]*>/g, "");
}

function getMinuteOffset(aTimeZoneName) {
    "use strict";
    var lMomentOffset,
        lIsNegative = false,
        lOffset = 0;

    if (aTimeZoneName) {
        lMomentOffset = moment().tz(aTimeZoneName).format('Z');
    } else {
        lMomentOffset = moment().format('Z');
    }

    if (lMomentOffset.indexOf('-') !== -1) {
        lIsNegative = true;
        lMomentOffset = lMomentOffset.replace(/-/, '');
    }

    var lSplitter = lMomentOffset.split(':');

    lOffset = parseFloat(lSplitter[0]) * 60 + parseFloat(lSplitter[1]);
    if (lIsNegative) {
        lOffset = -Math.abs(lOffset);
    }

    return lOffset;
}

function ReportEmailFormatter(aId) {
    "use strict";
    var lReportScheduleEmailFilter = getDataItem(aId, 'ReportScheduleEmailFilter');
    var lValue = '';

    if (lReportScheduleEmailFilter) {
        lValue = lReportScheduleEmailFilter.ShortName;
    }

    return lValue;
}


function populateDropDown(aId, aList, aDefault) {
    "use strict";
    var id = $('#' + aId);
    var lList = [];
    var lKey;

    for (lKey in aList) {
        if (aList.hasOwnProperty(lKey)) {
            lList.push(new Option(lKey, aList[lKey]));
        }
    }

    id.append(lList);

    if (aDefault) {
        id.prepend(new Option('Please select....',- 1));
    }
}

// LOCALIZATION FORMATTERS
function checkTranslationStatus() {
    "use strict";
    var lPreferences = getUserPreferences(13),
        lHasCulture = false,
        lPreference;

    if (count(lPreferences) > 0) {
        lPreference = lPreferences['CultureId'];
        if (!isNullOrUndefined(lPreference) && lPreference.Value != -1) {

            if (parseInt(lPreference.Value) > 0) {
                lHasCulture = true;
            }
        }
    }

    return lHasCulture;
}

function localizeWrapper(aLocale) {
    return '<span class="cLocalize ' + aLocale + '">' + locale[aLocale] + '</span>';
}

function localizeText(aLocale) {
    var localeValue;
    var localeText = veritracks.localization.getPhraseValue(aLocale);

    if (!localeText)
        localeText = locale[aLocale];
    return localeText;
}

function localizeDataItem(aCacheName, aReturn) {
    "use strict";
    var lReturn = aReturn;
    var lDefault = aReturn;

    if (checkTranslationStatus()) {
        lReturn = veritracks.localization.phraseBuilder(aCacheName, lReturn);
        lReturn = localizeText(lReturn);
    }
    if (!lReturn) {
        lReturn = lDefault;
    }
    return lReturn;
}

function localizeTitleFormatter(aTitle) {
    "use strict";
    var lTitle = aTitle,
        lDefault = aTitle,
        newTitle = '';

    if (aTitle && checkTranslationStatus()) {
        if (aTitle.length > 1 && aTitle[0] == aTitle[0].toLowerCase() && aTitle[1] == aTitle[1].toUpperCase()) {

        } else {
            newTitle = lTitle.replace(/\w+/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1);
            }).replace(/\s/g, '');

            newTitle = 'c' + newTitle;

        }
        newTitle = localizeText(newTitle);
    }
    if (!newTitle) {
        newTitle = lDefault;
    }

    return newTitle;
}

function notificationTypeFormatter(aValue) {
    "use strict";

    return localizeDataItem('NotificationType', aValue);
}

function AddressTypeFormatter(aValue) {
    "use strict";

    return localizeDataItem('AddressType', aValue);
}

function OrganizationAddressTypeValueFormatter(aValue){
    "use strict";

    return localizeDataItem('OrganizationAddressType', aValue);
}

function OrganizationAddressTypeFormatter(aAddressTypeId) {
    "use strict";
    var lName = localizeWrapper('cUnknown'),
        lAddressType = getDataItem(aAddressTypeId, 'OrganizationAddressType');

    if (!isNullOrUndefined(lAddressType)) {
        lName = localizeDataItem('OrganizationAddressType', lAddressType.Description);
    }

    return lName;
}

function IsRequiredFormatter(aIsRequired) {
    "use strict";
    if (aIsRequired) {
        return localizeText('cTrue');
    } else {
        return localizeText('cFalse');
    }
}

function VisitFrequencyFormatter(aFrequency) {
    "use strict";


    return localizeDataItem('VisitFrequency', aFrequency);
}

function MatchTypeFormatter(aMatchType) {
    "use strict";

    return localizeDataItem('EnrolleeTimelineMatchType', aFrequency);
}

function EnrolleeTypeFormatter(aEnrolleeType) {
    var lType = '';

    if (aEnrolleeType == 1) {
        lType = localizeText('cEnrolleeOffender');
    } else {
        lType = localizeText('cEnrolleeVictim');
    }

    return lType;
}
/**
 * using mEnrolleesData.OffenderCurrentId
 * @param  {} aDate
 */
function formatDisplayDateTimeAgentTimeZone(aDate){
    "use strict";
    var lZone = -1,
        lResults;
        lZone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId);
    lResults = DisplayShortDateTime(new Date(displayFixedTimeZoneTime(aDate, lZone.TimeZoneName)));

    return lResults;
}

function formatDateTimeToEnrolleeTimezone(aDate,aEnrolleeId){
    var lResult = null,
    lTimeZone = null;
    lTimeZone = getEnrolleeTimeZone(aEnrolleeId);
    lResult = DisplayShortDateTime(new Date(displayFixedTimeZoneTime(fixDate(aDate), lTimeZone.TimeZoneName)));
    return lResult; 
}

/**
 * formatStartEndDateTimeToEnrollee@function
 * format StartDate or EndDate time to selected enrollee timezone
 * This Function will run fixDate to parse
 * /Date(12312312)/ Wcf to Date format
 * @param  {} aDate
 */
function formatStartEndDateTimeToEnrollee(aDate) {
    "use strict";
    var lResult = null,
        lTimeZone = null;
    lTimeZone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId);
    lResult = displayEnrolleeTimeZoneFormatted(fixDate(aDate), lTimeZone);
    return lResult;
}
function DisplayShortDateTimeAgentTimeZone(aDate) {
    "use strict";
    var lZone = -1,
        lResults;

    lZone = getEnrolleeTimeZone(mEnrolleesData.CurrentAlcoholSchedule.EnrolleeId);
    lResults = DisplayShortDateTime(new Date(displayFixedTimeZoneTime(aDate, lZone.TimeZoneName)));

    return lResults;
}

function CarveOutScheduleTitle(aStart, aEnd, aScheduleType, aReocurring, aSelectionText) {
    "use strict";

    return [
        aStart.format('dddd'),
        '-',
        aSelectionText
    ].join(' ');
}


function formatTo12Hours(time) {
    return moment(time, "HH:mm").format("hh:mm A")
}


function getTimeFormatter(time) {
    if (!time) return "";
    var timeArray = time.split(" ");
    return timeArray[1] + " " + timeArray[2]
}

function getCheckInFormatter(id) {
    var schedule = GetOffenderSchedule(id);

    if (!schedule) return;

    if (schedule.ScheduleType == 6) {
        return '- check-in -';
    } else {
        return getTimeFormatter(schedule.StartTimeLocal);
    }
}

function getEmptyFormatter() {
    return '';
}

function durationFormatter(aDurationInMins) {
    var MINS = 60;
    var HRS = 24;
    var DAYS = 360;

    if (aDurationInMins < MINS) {
        return aDurationInMins + "M";
    } else if ((aDurationInMins / MINS) < HRS) {
        return Math.round(parseFloat(aDurationInMins / MINS)) + "H";
    } else if ((aDurationInMins / (MINS * HRS)) < 99) {
        return Math.round(parseFloat(aDurationInMins / (MINS * HRS))) + "D";
    } else {
        return Math.round(parseFloat(aDurationInMins / (MINS * HRS * DAYS))) + "Y";
    }
}
/**
 * Used in the Enrollee Card View list. 
 * This function returns the css class to be used in the 
 * @legacy
 * @param {*} aTotalTestNum 
 * @returns 
 */
function sobertrackTotalTestFormatter(aTotalTestNum) {   
    if (aTotalTestNum == 'None') {
        return '';    
    } else if (aTotalTestNum == 'Normal') {
        return 'SoberTrackUsageNormal';
    } else if (aTotalTestNum == 'Warning') {
        return 'SoberTrackUsageWarning';
    } else {
        return 'SoberTrackUsageCritical';
    }
}
/**
 * This function returns a formated text with given number of tests. 
 * @param {*} aTotalTestNum 
 * @returns  param +"cEnrolleeTotalNumberOfTests"
 */
function soberTrackTotalOfTestsFormatter(aTotalTestNum) {
    const SOBERTRACK_MAX_TEST_THRESHOLD = veritracks.system.clientSetting('SobertrackUsageTestLimit') ?? 1800;//#No. Tests

    return aTotalTestNum+' out of '+ SOBERTRACK_MAX_TEST_THRESHOLD +' tests';
}
function soberTrackDaysInUseFormatter(aNumberOfDays) {
    const SOBERTRACK_MAX_DAYS_IN_FIELD_THRESHOLD = veritracks.system.clientSetting('SobertrackDaysInFieldLimit') ?? 180;// In Days
    return aNumberOfDays +' out of '+ SOBERTRACK_MAX_DAYS_IN_FIELD_THRESHOLD + ' days';
}

function soberTrackUsageFormatter(aStatus) {
    if (aStatus == undefined || aStatus == null) {
        return undefined;
    } else {
        return 'Device Status: '+aStatus;
    }
}
function sobertrackConfirmedTestFormatter(aIsConfirmed){
    var nc = localizeWrapper('cEventNotConfirmed2'), c =localizeWrapper('cSoberTrackConfirmed')
    return  aIsConfirmed ? c : nc;
}

function sobertrackInProgressTestFormatter(aEvent, aMaxReTest) {

    if (aMaxReTest > aEvent.NumberRetest) {
        var lMaxtTestStart = moment(aEvent.StartDate).utc();
        var lNowTestDate = moment().utc();
        var lMaxInc = aMaxReTest * 15;
        lMaxtTestStart.add(lMaxInc, 'minutes');
        if (lNowTestDate > lMaxtTestStart) {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}



function parseUSAddress(aAddress) {
    var mStreetRegex = /(\d+)\s(\w+\s)+\w{0,}[,]\s/;
    var mCityRegex = /[A-z]+,\s/;
    var mStateRegex = /[A-z]{2}\s/;
    var mZipCodeRegex = /\b\d{5}(?:-\d{4})?\b,\s/;
    var mUSAddressRegex = /((\d+)\s(\w+\s)+\w{0,}[,]\s)([A-z]+,\s)([A-z]{2}\s)(\b\d{5}(?:-\d{4})?\b), (US|^USA$|us|usa)?/;
    var mStreetFound = '';
    var mCityFound = '';
    var mStateZipFound = '';
    var mStateFound = '';
    var mZipFound = '';
    var mCountryFound = '';
    var mCurrentString = aAddress;
    //{mStreetRegex},\s{mCityRegex},\s({mStateRegex})\s{mZipCodeRegex}/;
    mCurrentString = mCurrentString.split(",")
    if (mCurrentString.length > 0) {
        mStreetFound = mCurrentString[0].trim();
    }

    if (mCurrentString.length > 1) {
        mCityFound = mCurrentString[1].trim();
    }

    if (mCurrentString.length > 2) {
        mStateZipFound = mCurrentString[2].trim().split(" ");
        mStateFound = mStateZipFound[0];
        if (mStateZipFound.length > 1) {
            mZipFound = mStateZipFound[1];
        }
    }

    if (mCurrentString.length > 3) {
        mCountryFound = mCurrentString[3].trim();
    }

    if (mStreetFound != '' && mCityFound != '' && mStateFound != '' && mZipFound != '' && mCountryFound != '') {
     return { 'StreeName': mStreetFound, 'City': mCityFound, 'State': mStateFound, 'Zip': mZipFound, 'Country': mCountryFound };
    } else {
        return aAddress;
    }
}


function GeodesicDistance(latln1, latln2) {
    //dist in km = arccos(sin(lat1) · sin(lat2) + cos(lat1) · cos(lat2) · cos(lon1 - lon2)) · R
    var lat1 = 0,
        lat2 = 0,
        lng1 = 0,
        lng2 = 0,
        PI = Math.PI,
        radius = 0,
        R = 6371; //spherical approximation of the figure of the Earth

    //convert degrees to radians
    lat1 = latln1.lat * (PI / 180);
    lat2 = latln2.lat * (PI / 180);
    lng1 = latln1.lng * (PI / 180);
    lng2 = latln2.lng * (PI / 180);

    radius = Math.acos(Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng1 - lng2)) * R;
    radius = radius / .001; //convert to meters
    //less than 20 feet return 100 feet in meters
    if (radius < 5) {
        return 30;
    }

    return radius;
}
/**
 * Takes Overlay(Layer.js ) Sumo Data ( playbac ) and returns a Date. 
 * @param {Object} aSumoData must contain cardViewPrefix
 * @returns 
 */
function overlayDateFormatter(aSumoData) {
    if (!aSumoData.hasOwnProperty('cardViewPrefix')){
        return new Date();
    }
    switch (aSumoData.cardViewPrefix) {
        case 'v':
            return new Date(aSumoData.StartDateUTC);
        case 't':
            return new Date(aSumoData.TrackDateUTC);
        default:
            return new Date();
    }
}

function bookmarkTypeIdFormatter(aSumoData){
    if(!isNullOrUndefined(aSumoData.__type)&& aSumoData.__type ==='Event:www.veritracks.com'){
        return 1; // Event 1 
    }
    switch (aSumoData.cardViewPrefix) {
        case 'v':
            return 2;//Visit
        case 't':
            return 3;//TrackPoint
        default:
            return 1;//Event
    }
}
function AddEventNotePopup(aEventId) {
    var aEvent = getDataItem(aEventId, 'Events');
    var lButtons = GenerateButtonCommandBar(),
    lOkButton = GenerateButton(localizeWrapper('cSave'), 'Save', function(){
        bookmarkConfirmEvent(aEventId);
    }),
    lCancelButton = GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', function(){
        ClosePopup();
    });
    const lHTML = `
        <textarea id="uAddNoteTextArea" class="AddNoteTextArea" onkeyup="noteManager_OnChange()" style="width: 490px;"></textarea>
    `;
    DisplayPopup(`${localizeWrapper('cEnrolleeAddNewNote')} to ${formatterMetaEvent(aEvent.MetaEventId)} - ${aEvent.Id}`, lHTML, lButtons, true);

}
function ConfirmEventPopup(aEventId) {
    var aEvent = getDataItem(aEventId, 'Events');

    var lButtons = GenerateButtonCommandBar(),
        lOkButton = GenerateButton(localizeWrapper('cEnrolleeConfirm'), 'Save', function(){
            bookmarkConfirmEvent(aEventId);

        }),
        lCancelButton = GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', function(){
            ClosePopup();
        });
    lOkButton.appendTo(lButtons);
    lCancelButton.appendTo(lButtons);
    
    const lHTML = `
        <table>
            <thead>
                <tr>
                <th colspan="2">Event: ${formatterMetaEvent(aEvent.MetaEventId)}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                <td>Id:</td>
                    <td>${aEvent.Id}</td>
                </tr>
                <tr>
                    <td>${localizeWrapper('cEventStartDate')}:</td>
                    <td>${formatEventStartDateTime(aEvent)}</td>
                </tr>
                <tr>
                    <td>${localizeWrapper('cEventStopDate')}:</td>
                    <td>${formatEventEndDateTime(aEvent)}</td>
                </tr>
                <tr>
                    <td>Status:</td>
                    <td>${EventOpenFormatter(aEvent.IsOpen)}</td>
                </tr>
                <tr>
                    <td>${localizeWrapper('cEventConfirmed')}:</td>
                    <td>${EventConfirmedFormatter(aEvent.IsConfirmed)}</td>
                </tr>
            </tbody>
            </table>
            <div sytle="padding:5px;">
                <div>${localizeWrapper('cEnrolleeAddNote')}</div>
                <div>
                    <textarea id="uBookmarkEventNewNote" type="text" style="width:90%;height: 100px;margin-bottom:10px;margin-top:5px;" placeholder=""></textarea>
                </div>
            </div>
    `;
    DisplayPopup(`Confirm Event: ${formatterMetaEvent(aEvent.MetaEventId)} - ${aEvent.Id}`, lHTML, lButtons, true);
} 

function bookmarkEventDataFormatter(aEvent) {
    const ConfirmedComponent = aEvent.IsConfirmed?'':`<div class="Button OkButton LargeIconButton Clickable pEventsWrite" id="uEnrolleesEventConfirmButton-${aEvent.Id}" onclick="ConfirmEventPopup(${aEvent.Id})" style="display: block;"><span class="cEnrolleeConfirm">Confirm</span></div>`;
    return `
        <h3>Event: ${formatterMetaEvent(aEvent.MetaEventId)}</h3>
        <p>Id:${aEvent.Id} - <span class="GridIcon EventIcon16 StopClickBubble"; onclick="enrolleesEMAEventsIcon_OnClick('${aEvent.Id}')"></span><br/>
        Start Date: ${formatEventStartDateTime(aEvent)}<br/>
        Stop Date: ${formatEventEndDateTime(aEvent)}<br/>
        Status: ${EventOpenFormatter(aEvent.IsOpen)}<br/>
        Confirmed: ${EventConfirmedFormatter(aEvent.IsConfirmed)}
        </p>
        ${ConfirmedComponent}
    `;
}
/**
 * This function will format en Visit Data  into an HTML text used by the PlayBack Bookmark tool-tip
 * @param {TrackPoint} aData 
 * @returns 
 */
function bookmarkFrequentVisitDataFormatter(aData) {
    return `
        <h3>Frequently Visited Location</h3>
        <p>Number of Visits: ${aData.Frequency}<br/>
        Duration of Visit: ${durationFormatter(aData.Duration)}<br/>
        Start Date: ${DisplayShortDateTime(aData.StartDate)}<br/>
        Stop Date: ${DisplayShortDateTime(aData.EndDate)}</p>
    `;
}


function bookmarkConfirmEvent(aEventId) {
    if(aEventId){
        var lNoteText = $('#uBookmarkEventNewNote').val();
        var lEvent = getDataItem(aEventId, 'Events');
        lEvent.TransactionId = moment().format("YYYYMMDDHHmmss");
        lEvent.IsConfirmed = true;
        lEvent.ConfirmedByUserId = gUserDetails.UserId;
        lEvent.ConfirmedDateUTC = new Date();
        // some events are in history and will mess up cache -- always save from Events and not EventHistory.
        lEvent.__type = "Event:www.veritracks.com";
        var lData = [prepareObjectForWcf(lEvent)];       
        //Prepare Note data and Save
        WriteMultiple(lData, function(aParams,aData){
            enrolleesEventConfirmationWrite_OnSuccess(aParams,aData);
            mEnrolleesControls.PlaybackControl.removeBookmarks();
            mEnrolleesControls.PlaybackControl.bookmarkAdd('Events',bookmarkEventDataFormatter);
            mEnrolleesControls.PlaybackControl.bookmarkAdd('FrequentVisits',bookmarkFrequentVisitDataFormatter);
            ClosePopup();
            // Check if text is in Note and Save Note if it is
            
            if ($.trim(lNoteText) !== '') {
                var lNote = new Note(gUserDetails.UserId, lNoteText);
                lNote.__type = 'Event' + lNote.__type;
                lNote.EventId = aEventId;
                var lCurrent = mEnrolleesData.OffenderCurrentId;
                if (mStateManager.Settings()[0] === 'Victims') {
                    lCurrent = mEnrolleesData.VictimCurrentId;
                }
                console.log('lNote',[lNote],lData);
                    
                WriteMultiple([lNote], function(){
                    // mActivityNotification.addNotification(aData.length.toString() + localizeWrapper('EventNoteAdded'), 'Note', 'Note', lCurrent);

                }, confirmNote_OnWriteFailure, lCurrent);
            }
            setDataItem(lEvent.Id, 'Events', lEvent)
        }, enrolleesEventConfirmationWrite_OnFailure, lEvent);


        
        
        
    }
}


if (typeof exports !== 'undefined') {
    module.exports = {VictimRiskLevelFormatter,EnrolleesSoberTrackTestStatusFormatter}
}